import { render, staticRenderFns } from "./meter_expenses.vue?vue&type=template&id=5b39c963&scoped=true&"
import script from "./meter_expenses.vue?vue&type=script&lang=js&"
export * from "./meter_expenses.vue?vue&type=script&lang=js&"
import style0 from "./meter_expenses.vue?vue&type=style&index=0&id=5b39c963&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39c963",
  null
  
)

export default component.exports